<template>
  <a-spin :spinning="spinning">
    <a-card>
      <div class="search">
        <a-form layout="horizontal" :model="form">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="日期" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
                <a-month-picker v-model="form.date" format="YYYY-MM" placeholder="请选择日期" @change="changeDate" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-button type="primary" @click="search()">查询</a-button>
              <div class="space"></div>
              <a-button type="default" @click="reset()">重置</a-button>
            </a-col>
          </a-row>
          <a-row style="text-align: left">
            <a-button type="primary" @click="printJson"><span class="iconfont icon-print"></span><span
                style="margin-left: 5px">打印</span></a-button>
            <a-button style="margin-left: 10px" type="default" @click="export2Excel">
              导出excel</a-button>
          </a-row>
        </a-form>
      </div>
      <div class="table" style="margin-top: 10px">
        <standard-table :columns="columns" :dataSource="listData" :loading="loading" :pagination="pagination"
          @change="onChange" bordered>
          <template slot="title">
            <h2 style="margin-bottom: 0px">运输车队{{ month }}月应收款汇总</h2>
          </template>
        </standard-table>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import StandardTable from "@/components/StandardTable";
import { account_receivable_list } from "@/api/modules/summaryManagement.js";
import printJS from "print-js";
export default {
  name: "accountReceivableManagement",
  created() {
    this.form.date = this.$moment(new Date()).format("YYYY-MM");
    this.month = new Date().getMonth() + 1;
    this.search();
  },
  mounted() {
    this.handleListData();
  },
  data() {
    return {
      spinning: false,
      loading: false,
      month: "",
      listDataExcel: null,
      listData: [],
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        current: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      form: {
        date: "",
      },
      columns: [
        {
          title: "客户",
          dataIndex: "notPayCustomer",
          align: "center",
        },
        {
          title: "车数",
          dataIndex: "notPayBusTotal",
          align: "center",
        },
        {
          title: "品名",
          dataIndex: "notPayGoodsName",
          align: "center",
        },
        {
          title: "重量",
          dataIndex: "notPayWeight",
          align: "center",
        },
        {
          title: "单价",
          dataIndex: "notPayUnitPrice",
          align: "center",
        },
        {
          title: "金额",
          dataIndex: "notPayMoney",
          align: "center",
        },
      ],
    };
  },
  components: {
    StandardTable,
  },
  methods: {
    search() {
      if (!this.form.date) {
        return this.$message.warn("日期不能为空")
      }
      let dateArr = this.form.date.split("-");
      if (dateArr[1].charAt(0) == "0") {
        this.month = dateArr[1].charAt(1);
      } else {
        this.month = dateArr[1];
      }
      let params = {
        date: this.form.date + "-01",
      };
      this.loading = true;
      account_receivable_list(params).then((res) => {
        this.loading = false;
        if (res.code == "0000") {
          this.listData = res.data;
          this.handleListData();
          this.pagination.total = res.data.totalCount;
        } else {
          this.$message.warn(res.msg);
        }
        this.loading = false;
      });
    },
    handleListData() {
      this.listData = this.listData.map((item) => {
        for (let key in item) {
          if (key == "notPayWeight") {
            item[key] = item[key].toFixed(2);
          }
          if (["notPayUnitPrice", "notPayMoney"].some((ele) => ele == key)) {
            item[key] = this.returnFloat(item[key].toLocaleString(), "price");
          }
        }
        return item;
      });
    },
    changeDate(val) {
      if (val == null || val == undefined || val == "") {
        return (this.form.date = "");
      }
      this.form.date = this.$moment(val).format("YYYY-MM");
    },
    reset() {
      this.form.date = this.$moment(new Date()).format("YYYY-MM");
    },
    //金额或数量小数点不足两位自动补零
    returnFloat(value, flag) {
      var s = value.toString().split(".");
      if (s.length == 1 && flag == "price") {
        value = value.toString() + ".000";
        return value;
      } else if (s.length == 1 && flag == "weight") {
        value = value.toString() + ".00";
        return value;
      }
      if (s.length > 1 && flag == "price") {
        if (s[1].length == 1) {
          value = value.toString() + "00";
        }
        if (s[1].length == 2 && flag == "price") {
          value = value.toString() + "0";
        }
        return value;
      } else if (s.length > 0 && flag == "weight") {
        if (s[1].length == 1) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    //表格数据打印
    printJson() {
      let data = [];
      for (let i = 0; i < this.listData.length; i++) {
        data.push({
          field1: this.listData[i].notPayCustomer,
          field2: this.listData[i].notPayBusTotal,
          field3: this.listData[i].notPayGoodsName,
          field4: this.listData[i].notPayWeight,
          field5: this.listData[i].notPayUnitPrice,
          field6: this.listData[i].notPayMoney,
        });
      }
      console.log(data);
      printJS({
        printable: data,
        properties: [
          {
            field: "field1",
            displayName: "客户",
            columnSize: 1,
          },
          {
            field: "field2",
            displayName: "车数",
            columnSize: 1,
          },
          {
            field: "field3",
            displayName: "品名",
            columnSize: 1,
          },
          {
            field: "field4",
            displayName: "重量",
            columnSize: 1,
          },
          {
            field: "field5",
            displayName: "单价",
            columnSize: 1,
          },
          {
            field: "field6",
            displayName: "金额",
            columnSize: 1,
          },
        ],
        type: "json",
        header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>应收汇总表</h3> 
                    </div>`,
        // 样式设置
        gridStyle: "border: 1px solid #e8e8e8;text-align:center",
        gridHeaderStyle: "color: #999;  border: 1px solid #ccc;",
      });
    },
    async export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../excel/Export2Excel");
        const tHeader = [
          "未付款客户",
          "未付款车数",
          "未付款品名",
          "未付款重量",
          "未付款单价",
          "未付款金额",
        ];
        const filterVal = [
          "notPayCustomer",
          "notPayBusTotal",
          "notPayGoodsName",
          "notPayWeight",
          "notPayUnitPrice",
          "notPayMoney",
        ];
        const data = this.formatJson(filterVal, this.listData);
        export_json_to_excel(tHeader, data, "应收汇总表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    onChange(val) {
      this.pagination.current = val.current;
      this.search(this.pagination.current);
    },
  },
};
</script>

<style lang="less" scoped>
.space {
  display: inline-block;
  margin: 0 5px;
}

.ant-form-item-label {
  width: 100px;
}

.ant-calendar-picker {
  width: 100%;
}

/deep/ .ant-table-title {
  background-color: #f8f8f8;
}
</style>
